// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-text-image[data-v-7aa402d6]{width:100%;min-height:90vh;background-color:#fff;border-top:1px solid #373534}.img-container[data-v-7aa402d6]{min-height:80vh;width:100%}@media only screen and (max-width: 959px){.img-container[data-v-7aa402d6]{min-height:60vh}}.image[data-v-7aa402d6]{position:relative;height:100%;width:80%;left:10%;background-size:contain;background-position:center}", ""]);
// Exports
module.exports = exports;
